<template>
  <a-modal
    title="固定价"
    :width="680"
    :visible="visible"
    :confirmLoading="loading"
    @ok="ok"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form" v-bind="formLayout">
        <a-row :gutter="[16,16]">
          <a-col :span="24">
            <a-form-item label="计价日期">
              <a-date-picker
                format="YYYY-MM-DD"
                placeholder="计价日期"
                value-format="yyyy-MM-DD"
                v-decorator="['lock_price_date', {rules: [{required: true, message: '必填项，请填写信息'}]}]">
              </a-date-picker>
            </a-form-item>
            <a-form-item label="计价数量">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['lock_count', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
            <a-form-item label="计价价格">
              <a-input-number style="width: 50%" :precision="4" v-decorator="['lock_price', {rules: [{required: true, message: '必填项，请填写信息'}]}]" placeholder="请输入"/>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
export default {
  components: {},
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    },
    model: {
      type: Object,
      default: () => null
    }
  },
  data () {
    this.formLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      }
    }
    return {
      form: this.$form.createForm(this),
      dictionaries: this.$Dictionaries,
      param: {}
    }
  },
  methods: {
    getCurrentStyle (current, today) {
      const style = {}
      if (current.date() === 1) {
        style.border = '1px solid #1890ff'
        style.borderRadius = '50%'
      }
      return style
    },
    ok () {
      this.$emit('ok')
    }
  }
}
</script>
